import React from "react";
import { t } from "@common/helpers/translator";
import CountDownComponent from "../countDownClock";
import Config from "../../../config/main";

export default function lockTerminalTemplate () {
    let {balance} = this.state,
        {profile, terminalBalance} = this.props,
        userBalance = profile && profile.balance,
        currency = this.state.currency,
        finalBalance = (userBalance === undefined ? null : userBalance + "") || (terminalBalance !== undefined ? terminalBalance !== null ? terminalBalance : balance === null ? 0 : balance : balance === null ? 0 : balance);

    return <div className="ticket-results-view-p">
        <CountDownComponent second={30} />
        <div className="mini-logo-view">
            <div className="mini-logo-container"></div>
            <p className='cashout-text'>{t(Config.cashoutTitle)}
                {
                    Config.showBalanceInCashoutMenu && this.state.currency !== undefined && this.state.balance !== undefined && ` ${finalBalance} ${currency} ?`
                }
                {
                    Config.enableCashoutbyTicketandCash && <div className='back-arrrow' onClick={this.props.openPopup('cashOutType')}></div>
                }
            </p>
            <div className="buttons-view-w-t">
                <ul>
                    <li>
                        <div className="separator-box-buttons-m">
                            <button className="button-view-normal-m"
                                onClick={this.cashOut()}>
                                {t("Yes")}
                            </button>
                        </div>
                    </li>
                    <li>
                        <div className="separator-box-buttons-m">
                            <button className="button-view-normal-m trans-m"
                                onClick={this.props.closePopup()}>
                                {t("Cancel")}
                            </button>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>;
}